import { useRequest } from 'features/request/useRequest';
import { useDebounce } from 'uikit';

import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimIsUniqueWorkOrderChangeInternalNumberGql } from '../bimWorkOrderChangeCreateOrEditQueries';

interface IUseIsUniqueWorkOrderChangeInternalNumber {
    workOrderChangeId: number;
    newInternalNumber: string | undefined;
    workOrderId: number;
    isCreating: boolean | undefined;
}

export const useIsUniqueWorkOrderChangeInternalNumber = ({
    workOrderChangeId,
    newInternalNumber,
    workOrderId,
    isCreating,
}: IUseIsUniqueWorkOrderChangeInternalNumber) => {
    const dispatch = useDispatch();

    const variables = useMemo(() => {
        if (newInternalNumber) {
            return {
                internalNumber: newInternalNumber,
                workOrderId,
                workOrderChangeId: isCreating ? null : workOrderChangeId,
            };
        }

        return null;
    }, [isCreating, newInternalNumber, workOrderChangeId, workOrderId]);

    const [isUniqueData, , , isUniqueRequest] = useRequest({
        requestId: 'bimIsUniqueWorkOrderChangeInternalNumber',
        query: bimIsUniqueWorkOrderChangeInternalNumberGql,
        withEffect: false,
    });

    const debounceCheck = useDebounce(() => {
        if (variables) {
            dispatch(isUniqueRequest(variables));
        }
    }, 500);

    useEffect(() => debounceCheck(), [debounceCheck, newInternalNumber]);

    return isUniqueData?.bimIsUniqueWorkOrderChangeInternalNumber?.result ?? true;
};
